export const PRESET_INSTRUCTION_KEYS = ["formal", "informal"] as const;
export const INSTRUCTION_KEYS = [...PRESET_INSTRUCTION_KEYS, "custom"] as const;
export const SKILL_INSTRUCTION_MODES = ["inherit", ...INSTRUCTION_KEYS] as const;
export const CUSTOM_INSTRUCTION_MAX_LENGTH = 1000;
